import React from 'react';
import './tailwind.css'
import image from '../assets/images/book.png'

const SlidingImageAnimation = () => {
  return (
    <div className="flex items-center overflow-hidden">
      <div className="flex animation-slide">
        <img src={image} alt="Image 1" className="w-48 h-auto m-4 rounded-2xl" />
        <img src={image} alt="Image 2" className="w-48 h-auto m-4 rounded-2xl" />
        <img src={image} alt="Image 3" className="w-48 h-auto m-4 rounded-2xl" />
        <img src={image} alt="Image 3" className="w-48 h-auto m-4 rounded-2xl" />
        <img src={image} alt="Image 3" className="w-48 h-auto m-4 rounded-2xl" />
        <img src={image} alt="Image 3" className="w-48 h-auto m-4 rounded-2xl" />
        <img src={image} alt="Image 3" className="w-48 h-auto m-4 rounded-2xl" />
        <img src={image} alt="Image 3" className="w-48 h-auto m-4 rounded-2xl" />
        <img src={image} alt="Image 3" className="w-48 h-auto m-4 rounded-2xl" />
        <img src={image} alt="Image 3" className="w-48 h-auto m-4 rounded-2xl" />
        {/* Add more images as needed */}
      </div>
    </div>
  );
};

export default SlidingImageAnimation;
